import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../AppIcon';

const MobileMenu = ({ isOpen, onClose, navigationItems, currentPath }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleLinkClick = () => {
    onClose();
  };

  const isActive = (path) => currentPath === path;

  return (
    <div className={`mobile-menu-overlay ${!isOpen ? 'closed' : ''}`}>
      <div className="mobile-menu-container">
        <nav className="mobile-menu-items">
          {navigationItems?.map((item) => (
            <Link
              key={item?.path}
              to={item?.path}
              className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
              onClick={handleLinkClick}
              title={item?.tooltip}
            >
              <Icon name={item?.icon} size={24} />
              <span>{item?.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default MobileMenu;